import {
    CustomerServiceFilled,
    GroupFilled,
    IxigoMoneyFilled,
    LogoutFilled,
    LuggageFilled,
    MultipleUsersFilled,
    PassportFilled,
    PersonFilled,
    PlanFilled,
} from '@ixigo/icons';
import { Organisation } from '../../enums/common';
import homeOutlined from '../../images/homeOutlined.svg';
import ixigoMoneyOutlined from '../../images/ixigoMoneyOutlined.svg';
import logo from '../../images/logo.svg';
import moreOutlined from '../../images/moreOutlined.svg';
import bus from '../../images/productBus.svg';
import flight from '../../images/productFlight.svg';
import hotel from '../../images/productHotel.svg';
import train from '../../images/productTrain.svg';
import tripsOutlined from '../../images/tripsOutlined.svg';
import { formatPrice, getOrganisation, isBrowser } from '../../utils/common';
import { getCookieHelpers } from '../../utils/cookie';

type Obj = { [key: string]: string | Date | Obj };

const org = getOrganisation();

const removeEmptyKeysFromObject = (obj: Obj) => {
    Object.keys(obj).forEach((key) => {
        if (
            Object.prototype.toString.call(obj[key]) === '[object Date]' &&
            (obj[key].toString().length === 0 || obj[key].toString() === 'Invalid Date')
        ) {
            delete obj[key];
        } else if (typeof obj[key] === 'object') {
            if (Object.keys(obj[key]).length === 0 && Object.prototype.toString.call(obj[key]) !== '[object Date]') {
                delete obj[key];
            } else {
                removeEmptyKeysFromObject(obj[key] as Obj);
                if (
                    Object.keys(obj[key] as Obj).length === 0 &&
                    Object.prototype.toString.call(obj[key]) !== '[object Date]'
                ) {
                    delete obj[key];
                }
            }
        } else if (obj[key] == null || obj[key] === '') {
            delete obj[key];
        }
    });
    return obj;
};

const createCBT = (url: string) => {
    if (isBrowser()) {
        const { at, clientId, ixiUID } = getCookieHelpers().getAllCookies();
        const obj = {
            at: at as string,
            ixiUID: ixiUID as string,
            clientId: clientId as string,
        };
        const nonEmptyObj = removeEmptyKeysFromObject(obj);
        const objStr = window.btoa(window.JSON.stringify(nonEmptyObj));
        return `${url}?cbt=${objStr}`;
    }
    return url;
};

export const LOGO = {
    [Organisation.ABHIBUS]: (
        <img
            src='https://static.abhibus.com/img/abhilogos/logo1.png'
            alt='abhibus.com'
            title='abhibus.com'
            width={82}
            height={40}
        />
    ),
    [Organisation.CONFIRMTKT]: (
        <img
            src='https://www.confirmtkt.com/img/brand/ctkt-logo-colour.png'
            alt='confirmtkt.com'
            title='confirmtkt.com'
            width={135}
            height={30}
        />
    ),
    [Organisation.IXIGO]: <img src={logo} alt='ixigo.com' title='ixigo.com' width={82} height={40} />,
}[org];

export const MENU_ITEMS = [
    {
        label: 'Flights',
        href: '/flights',
        img: flight,
    },
    {
        label: 'Trains',
        href: '/trains',
        img: train,
    },
    {
        label: 'Buses',
        href: '/buses',
        img: bus,
    },
    {
        label: 'Hotels',
        href: '/hotels',
        img: hotel,
    },
];

export const MORE_MENU_ITEMS = [
    {
        title: 'Book Visa',
        icon: PassportFilled,
        href: '/account',
        dynamicUrl: () => createCBT('https://ixigo.visa2fly.com'),
    },
    {
        title: 'Group Booking',
        icon: GroupFilled,
        href: 'https://rocket.ixigo.com/group/index.html?p=app_search_form',
    },
    {
        title: 'Plan',
        icon: PlanFilled,
        href: '/plan?ref=flight_web',
    },
];

export const getUserMenuItems = (name: string) => [
    {
        title: name,
        subtitle: 'My Profile',
        icon: PersonFilled,
        href: '/account',
    },
    {
        title: 'My Trips',
        subtitle: 'View & manage bookings',
        icon: LuggageFilled,
        href: '/account/trips',
    },
    {
        title: 'ixigo Money',
        subtitle: 'Your virtual currency',
        icon: IxigoMoneyFilled,
        href: '/finance/home',
    },
    {
        title: 'My Travellers',
        subtitle: 'View all saved travellers',
        icon: MultipleUsersFilled,
        href: '/account/travellers',
    },
    {
        title: 'Log out',
        subtitle: '',
        icon: LogoutFilled,
        href: '',
        key: 'logout', // Don't change this text as it is used for user logout.
    },
];

export const getNavbarItems = (balance?: number) => [
    {
        label: 'Home',
        icon: <img src={homeOutlined} alt='home' height={24} width={24} />,
        href: '/',
    },
    {
        label: 'ixigo Money',
        icon: <img src={ixigoMoneyOutlined} alt='ixigo money' height={24} width={24} />,
        href: '/finance/home',
        chipContent: formatPrice(balance),
    },
    {
        label: 'My Trips',
        icon: <img src={tripsOutlined} alt='my trips' height={24} width={24} />,
        href: '/account/trips',
    },
    {
        icon: <CustomerServiceFilled width={28} height={28} className='shrink-0 text-charcoal-800' />,
        label: 'Contact us',
        href: '/support',
    },
    {
        icon: <img src={moreOutlined} alt='more' height={24} width={24} />,
        label: 'More',
        href: '/account',
    },
];

export const isHeaderNavVisible = org === Organisation.IXIGO;
